export default __webpack_public_path__ + "locales/el-GR/ResetApplicationDialog.json?hash=1253b662d4a45090264805756b128cca";